<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="filter.type" @change="getList">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="spend">
            花费
          </a-radio-button>
          <a-radio-button value="revenue">
            收益
          </a-radio-button>
          <a-radio-button value="purchase">
            内购
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-input-number style="width: 100px;" @change="getList"
                        v-model="filter.error_rate" placeholder="误差率"></a-input-number>
      </a-form-item>
      <a-form-item>
        <a-radio-group button-style="solid" v-model="filter.filter" @change="getList">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="month">
            month
          </a-radio-button>
          <a-radio-button value="week">
            week
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <a-table :columns="dataField" :data-source="dataList" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table',extraHeight:74}) }"
             bordered :pagination="false">
      <template slot="type" slot-scope="text">
        {{text==='spend'?'花费':(text==='revenue'?'收益':'内购')}}
      </template>
      <template slot="start" slot-scope="text,recode">
        {{recode.start+" 到 "+recode.end}}
      </template>
      <template slot="error_rate" slot-scope="text">
        <a :style="{color:text>=5||text<=-5?'#ff4d4f':''}">{{Math.round(text*100)/100}}%</a>
      </template>
      <template slot="footer"  slot-scope="currentPageData">
        <a-pagination
          v-model="filter.page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="filter.page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template>
    </a-table>
  </div>
</template>

<script>
import {GetErrorDataPage} from "../../api/v1/base_info";

export default {
  name: "Index",
  data(){
    return {
      filter:{
        type:'',
        error_rate:'',
        page:1,
        page_size:10,
        filter: '',
      },
      dataField:[
        {title: '区间', dataIndex: 'start',key:'id', scopedSlots: { customRender: 'start' }},
        {title: '渠道', dataIndex: 'channel'},
        {title: '类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }},
        {title: '误差率', dataIndex: 'error_rate', scopedSlots: { customRender: 'error_rate' }},
        {title: '平台账单值', dataIndex: 'real_num',},
      ],
      dataList:[],
      count:0,
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    changePage(page,page_size){
      this.filter.page = page
      this.filter.page_size = page_size
      this.getList()
    },
    getList(){
      GetErrorDataPage(this.filter).then(resp => {
        if (resp.code===200){
          this.count = resp.data.count
          this.dataList = resp.data.list
          this.filter.page = resp.data.page
          this.filter.page_size = resp.data.page_size
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ErrorData/Index.vue